import { render } from "./AgentList.vue?vue&type=template&id=38b7ed33&ts=true"
import script from "./AgentList.vue?vue&type=script&lang=ts"
export * from "./AgentList.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/zhongyue/Desktop/work/hu-shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__